var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.155 22.8c.356 0 .645.269.645.6 0 .325-.279.59-.626.6H.845C.49 24 .2 23.731.2 23.4c0-.325.279-.59.626-.6zM10.85 0c.36 0 .65.294.65.657v16.64l4.392-4.348a.65.65 0 0 1 .922.01.66.66 0 0 1-.01.931l-5.494 5.435a.6.6 0 0 1-.204.131.65.65 0 0 1-.469 0 .6.6 0 0 1-.204-.131L4.896 13.89a.66.66 0 0 1-.01-.93.65.65 0 0 1 .922-.011l4.391 4.348V.657c0-.363.291-.657.651-.657"
  })));
};
export default SvgDownload;